import React, { useState, useEffect } from 'react'

import { startLoading, doneLoading } from '../../utils/loading'
import { getInfomaSystemDocument } from '../../redux/actions/infomaDocument'
import InfomaViewWidget from './InfomaViewWidget'
import { Panel } from 'rsuite'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import LoaderProcessing from '../../components/loader/LoaderProcessing'

export default function InfomaFilesWidget({ projectId, ...props }) {
  const [schema, setSchema] = useState()
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getInfomaSystemDocument(proposalId)
      setSchema(_schema.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <Panel header="เอกสารจากระบบ Infoma (โครงสร้างใหม่)">
        <Message showIcon type="error" description={DEFAULT_ERR_MSG} />
      </Panel>
    )
  }

  if (!schema || isLoading) {
    return (
      <Panel header="เอกสารจากระบบ Infoma (โครงสร้างใหม่)">
        <LoaderProcessing />
      </Panel>
    )
  }

  return (
    <>
      {schema && (
        <>
          {schema?.forms?.attachFiles && (
            <InfomaViewWidget header={schema.header} schema={schema.forms.attachFiles} />
          )}

          <br />
        </>
      )}
    </>
  )
}
